import React, { useEffect, useRef } from 'react';

import useStoreTranslation from 'hooks/useStoreTranslation';

import { ToastNeutral, ToastError } from './styles';

export interface ToastProps {
  type: 'success' | 'danger' | 'warning';
  noButton?: boolean;
  message: string;
  remove: () => void;
}

const Toast = ({ message, remove, type, noButton }: ToastProps) => {
  const { t } = useStoreTranslation();
  const removeRef = useRef<() => void>(remove);

  useEffect(() => {
    const duration = 6000;
    const id = setTimeout(() => removeRef.current(), duration);

    return () => clearTimeout(id);
  }, []);

  if (type === 'danger')
    return (
      <ToastError>
        <ToastError.Icon alt="error-icon" src="/images/toast-icon-error.svg" />
        <ToastError.Message>{message}</ToastError.Message>
        {!noButton && <ToastError.Button onClick={remove}>{t('toast.close')}</ToastError.Button>}
      </ToastError>
    );

  return (
    <ToastNeutral>
      {type === 'success' && <ToastNeutral.SuccessIcon />}
      {type === 'warning' && <ToastNeutral.WarningIcon />}
      <ToastNeutral.Message>{message}</ToastNeutral.Message>
      {!noButton && <ToastNeutral.Button onClick={remove}>{t('toast.close')}</ToastNeutral.Button>}
    </ToastNeutral>
  );
};

export default Toast;
